import React from "react";
import { useTranslation } from "react-i18next";
import aboutImg from "../../images/Home_Public_339ea30a2c.jpg";

const SectionWrap = ({ id, children }) => (
  <section id={id} style={{ padding: "60px 10%", backgroundColor: "#fff" }}>
    {children}
  </section>
);

const titleStyle = {
  fontSize: "28px",
  fontWeight: 700,
  color: "#0a2750",
  marginBottom: 12,
};

const pStyle = {
  fontSize: 16,
  color: "#222",
  lineHeight: 1.8,
  maxWidth: 860,
};

const EmiratesIntroSection = () => {
  const { t } = useTranslation();
  return (
    <SectionWrap id="about">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 40,
          alignItems: "start",
        }}
      >
        {/* Left column - all text */}
        <div>
          <h2 style={{ ...titleStyle, marginTop: 0 }}>
            {t("EmiratesMade.About.title", { defaultValue: "About Emirates Made" })}
          </h2>
          <div style={{ width: 64, height: 4, borderRadius: 2, background: "var(--uae-green)", marginBottom: 18 }} />

          <p style={{ ...pStyle, fontWeight: 700 }}>
            {t("EmiratesMade.About.p1", {
              defaultValue:
                "Emirates Made is a national initiative dedicated to promoting and empowering products and services manufactured within the United Arab Emirates.",
            })}
          </p>

          <ul
            style={{
              paddingLeft: 20,
              marginTop: 14,
              color: "#222",
              lineHeight: 1.8,
              maxWidth: 900,
              listStyle: "disc",
            }}
          >
            <li>
              {t("EmiratesMade.About.bullet1", {
                defaultValue:
                  "It reflects the country’s vision for sustainable industrial growth, innovation, and global competitiveness.",
              })}
            </li>
            <li style={{ marginTop: 8 }}>
              {t("EmiratesMade.About.bullet2", {
                defaultValue:
                  "Through this platform, Emirati manufacturers and service providers gain recognition, credibility, and access to wider markets—locally, regionally, and internationally.",
              })}
            </li>
          </ul>
        </div>

        {/* Right column - image placeholder */}
        <div>
          <div
            style={{
              width: "100%",
              aspectRatio: "4 / 3",
              borderRadius: 16,
              overflow: "hidden",
              boxShadow: "0 16px 40px rgba(0,0,0,0.10)",
              background: "#f2f5f4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={aboutImg}
              alt={t("EmiratesMade.About.imageAlt", { defaultValue: "Emirates Made" })}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
    </SectionWrap>
  );
};

export default EmiratesIntroSection;

